import { render, staticRenderFns } from "./RevenueOverTimeWidget.vue?vue&type=template&id=55986d7d"
import script from "./RevenueOverTimeWidget.vue?vue&type=script&lang=js"
export * from "./RevenueOverTimeWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports